"use strict";

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var illustration = function illustration(props) {
  var newProps = {
    className: props.getClassName('control-illustration'),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  };
  return React.createElement('div', newProps, props.children);
};

illustration.displayName = displayNames.ILLUSTRATION;
module.exports = compose(illustration);